<template>
    <div class="asynCurrentTasksColumn">
    <el-popover trigger="hover" placement="left">
        <template> 
             <el-table ref="taskTable" :data="taskInstanceList" style="width: 100%" :border="true"> 
              <el-table-column v-if="isShowTaskRound" label="任务驳回轮次" width="100">
                <template slot-scope="scope">
                  <template v-if="scope.row.hasOwnProperty('taskRound') && scope.row.taskRound>1" >第<el-tag type="danger" effect="dark" size="small">{{ scope.row.taskRound }}</el-tag>轮</template> 
                  <template v-else>第<el-tag size="small">1</el-tag>轮</template>
                </template>
             </el-table-column>  
              <el-table-column prop="name" width="220" label="任务名称" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <el-tag  v-if="!scope.row.hasOwnProperty('taskUser')" type="danger" size="small">{{ scope.row.name }}</el-tag>
                      <el-tag style="cursor:pointer;"  v-else-if="scope.row.hasOwnProperty('taskUser') " @click="checkTaskDetail(scope.row)" type="primary" size="small">{{ scope.row.name }}</el-tag>
                      <el-tag  v-else type="info" size="small">{{ scope.row.name}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="任务负责人" width="90">
                   <template slot-scope="scope">
                      <el-tag  v-if="!scope.row.hasOwnProperty('taskUser')" type="danger" size="small">未分配任务负责人</el-tag>
                      <el-tag  style="cursor:pointer;" v-else-if="scope.row.hasOwnProperty('taskUser') " @click="checkTaskDetail(scope.row)" type="primary" size="small">{{ scope.row.taskUser.trueName }}</el-tag>
                      <el-tag  v-else type="info" size="small">{{ scope.row.taskUser.trueName }}</el-tag>
                   </template>
                </el-table-column>
                <el-table-column label="审批流" :show-overflow-tooltip="true" width="70">
                  <template slot-scope="scope">
                     <el-tooltip v-if="scope.row.hasApproval === '1'" content="点击查看审批流详情，多条审批流时默认只显示最近一条审批流状态" slot="reference"  effect="light" placement="top">
                        <div class="approvalStatus" style="font-size: 13px;">
                            <span :class="activeClass(scope.row)" style="cursor: pointer;" @click="handleApprovalDetail(scope.row)">{{scope.row.relateApprovalStatusLabel}}</span>
                        </div>
                    </el-tooltip>
                  </template>
               </el-table-column>
                <el-table-column label="催办状态" width="100">
                   <template slot-scope="scope">
                      <el-tag  v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt>0" type="danger" size="small">已催办</el-tag>
                      <el-tag  v-else type="info" size="small">未催办</el-tag>
                   </template>
                </el-table-column>
                <el-table-column prop="created" label="任务开始时间" :sortable="true" width="150"></el-table-column>
                <el-table-column prop="taskInstanceDurationTime" label="任务耗时" sortable width="95" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column   label="操作"  width="100"> 
                  <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-bell" v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt==0" title="催办" circle @click="sendUrgeMessage(scope.row)"></el-button>
                        <el-button size="mini" icon="el-icon-bell" v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt>0" title="再次催办" circle @click="sendUrgeMessage(scope.row)"></el-button>
                        <el-button size="mini" v-if="isShowProcessDetail" icon="el-icon-view" title="流程详情" circle @click.stop="viewProcessDetail"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div slot="reference" class="name-wrapper">
            <!-- <el-tag  type="info" size="medium">{{taskInstanceList[0].name | ellipsis }}</el-tag> -->
            <!-- <el-tag  type="success" size="medium">{{taskInstanceList[0].name}}</el-tag> -->
            <el-tag style="cursor:pointer;" v-if="processInstanceStatus === 4" type="warning" size="medium">已终止</el-tag>
            <el-tag style="cursor:pointer;" v-else type="success" size="medium"> {{ taskInstanceList&&taskInstanceList[0]? taskInstanceList[0].name : '进行中' }} </el-tag>
              <div class="approvalStatus" style="font-size: 13px;float:right">
                <el-tooltip v-if="columnRow && columnRow.hasApproval === '1'" content="点击查看审批流详情，多条审批流时默认只显示最近一条审批流状态" slot="reference"  effect="light" placement="top">
                  <span :class="activeClass(columnRow)" style="cursor: pointer;" @click="handleApprovalDetail(columnRow)">{{columnRow.relateApprovalStatusLabel}}</span>
                </el-tooltip>
                <el-tooltip v-if="columnRow && columnRow.hasOwnProperty('noTaskUser')" content="当前任务未分配任务负责人，请联系管理员进行分配" slot="reference"  effect="light" placement="top">
                  <span class="reject" style="cursor: pointer;">未分配</span>
                </el-tooltip>
              </div>
          </div>
    </el-popover>
     <el-dialog
          title="流程详情"
          :fullscreen="true"
          append-to-body
          :visible.sync="isShowProcessInstanceDetail"
          >
         <ProcessDetail
            v-if="isShowDetail"
            :key="loadTimer"
            :instances="instancesInfo"
            :isRead="true"
          />
        </el-dialog>
        <el-dialog
            title="任务详情"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowTaskDetail"
            >
             <div style="margin-top: -20px;">
              <TaskDetail
                  class="popDetailTaskClass"
                  ref="taskDetailRef"
                  :taskInfo="taskInfo"
                  :isRead="true"
              />
             </div>
        </el-dialog>
        <el-dialog
            title="审批流进度"
            top="4vh"
            width="75%"
            :visible.sync="isShowDynamicApprovalPop"
            append-to-body
          >
            <DynamicApprovalPop
                :isStatus="true"
                :approvalDetail="approvalDetail"
                :cellValue="1"
            />
        </el-dialog>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';
// import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
import DynamicApprovalPop from '@/components/DynamicTable/DynamicApprovalPop';
import { getProcessCurrentTasks, sendUrgeMessage, getProcessInstancesDetail, getProcessTaskDetail, getProcessAllFormInstances, getApprovalInstanceDetail } from '@/data-model';
export default {
    components: {
    //     ProcessDetail: ProcessDetail,
        DynamicApprovalPop
    },
    filters: {
        ellipsis: function (value) {
            if (!value) return '';
            if (value.length > 5) {
                return value.slice(0, 5) + '...';
            }
            return value;
        }
    },
    data () {
        return {
            taskInfo: {},
            isShowTaskDetail: false,
            taskInstanceList: [],
            loadTimer: '',
            isShowDetail: false,
            isShowProcessInstanceDetail: false,
            instancesInfo: {},
            currentUserInfo: {},
            approvalDetail: {},
            isShowDynamicApprovalPop: false
        };
    },
    props: {
        isShowOverflowTooltip: {
            type: Boolean,
            default: false
        },
        isShowProcessDetail: {
            type: Boolean,
            default: false
        },
        column: {
            type: Object
        },
        columnRow: {
            type: Object
        },
        rowNumer: {
            type: Number,
            default: 0
        },
        cellValue: {
            type: String,
            default: ''
        },
        processInstanceName: {
            type: String,
            default: ''
        },
        processInstanceId: {
            type: String,
            default: ''
        },
        createdByName: {
            type: String,
            default: ''
        },
        createdDate: {
            type: String,
            default: ''
        },
        isFromBusTab: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        isShowTaskRound: {
            type: Boolean,
            default: false
        },
        processInstanceStatus: {
            type: Number,
            default: 0
        },
        closeFirstTaskCanDeleteBtn: {
            type: Boolean,
            default: false
        }
    },
    created () {
        this.isShowProcessInstanceDetail = false;
        let currentUserStr = sessionStorage.getItem('currentUserInfo');
        this.currentUserInfo = JSON.parse(currentUserStr);
        // this.taskInstanceList = [];
        // let processObj = { processInstanceId: this.processInstanceId, taskInstanceName: this.taskInstanceName, createdByName: this.createdByName, createdDate: this.createdDate };
        // this.taskInstanceList.push(processObj);
        console.log(this.columnRow);
        this.getProcessCurrentTasks();
    },
    methods: {
        async getProcessCurrentTasks () {
            if (isEmpty(this.processInstanceId)) {
                return;
            }
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.taskInstanceList = await getProcessCurrentTasks(this.processInstanceId, {isShowTaskRound: this.isShowTaskRound ? '1' : null});
            loading.close();
            if (this.taskInstanceList && this.taskInstanceList.length > 0) {
                let taskInstance = this.taskInstanceList[0];
                let approvalStatus;
                let approvalInstanceId;
                if (taskInstance.relateApprovalStatusList) {
                    if (taskInstance.relateApprovalStatusList.indexOf(',') !== -1) {
                        approvalStatus = taskInstance.relateApprovalStatusList.split(',')[0];
                    } else {
                        approvalStatus = taskInstance.relateApprovalStatusList;
                    }
                }
                if (taskInstance.relateApprovalInstanceIdList) {
                    if (taskInstance.relateApprovalInstanceIdList.indexOf(',') !== -1) {
                        approvalInstanceId = taskInstance.relateApprovalInstanceIdList.split(',')[0];
                    } else {
                        approvalInstanceId = taskInstance.relateApprovalInstanceIdList;
                    }
                }
                if (approvalStatus && approvalInstanceId) {
                    this.columnRow.hasApproval = '1';
                    this.columnRow.relateApprovalStatusLabel = taskInstance.relateApprovalStatusLabel;
                    this.columnRow.relateApprovalInstanceIdList = taskInstance.relateApprovalInstanceIdList;
                    this.columnRow.relateApprovalStatusList = taskInstance.relateApprovalStatusList;
                    this.columnRow.approvalStatus = approvalStatus;
                    this.columnRow.approvalInstanceId = approvalInstanceId;
                    // this.$emit('refreshTableBtn', this.columnRow, this.rowNumer);
                }
                if (!taskInstance.taskUser) {
                    this.columnRow.noTaskUser = true;
                }
            }
            if (!this.closeFirstTaskCanDeleteBtn) {
                if (this.columnRow.approvalStatus === '3') { // 流程任务里有驳回的审批流，直接显示删除流程的按钮
                    this.columnRow.isUndoProcess = true;
                    this.$emit('refreshTableBtn', this.columnRow, this.rowNumer);
                } else {
                    this.chkFirstTaskCanDelete();
                }
            }
        },
        async chkFirstTaskCanDelete () {
            let res = false;
            // this.currentProcessInstanceId = this.columnRow.id;
            if (this.columnRow && this.columnRow.id && !this.columnRow.children) {
                let tempFormsObj = await getProcessAllFormInstances({
                    processInstanceId: this.columnRow.id,
                    deploymentId: this.columnRow.processDefinitionDeploymentId
                });
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                // structure=tempFormsObj[0].structure;
                    let isHasVal = false;
                    let num = tempFormsObj.length;
                    if (num === 1) {
                        tempFormsObj.forEach(taskForm => {
                            let objModelFormInstance = this._getTemporaryFormInstance(taskForm);
                            if (objModelFormInstance) {
                                objModelFormInstance.forEach(form => {
                                    isHasVal = true;
                                    return false;
                                });
                            }
                        });
                        if (!isHasVal) { // 默认第一个任务，并且还没有生成表单数据
                            res = true;
                        }
                    }
                }
                if (res) {
                    this.columnRow.isUndoProcess = res;
                    this.$emit('refreshTableBtn', this.columnRow, this.rowNumer);
                }
            }
            return res;
        },
        _getTemporaryFormInstance (sourceForms) {
            let temporaryFormData;
            if (sourceForms && sourceForms.instance) {
                try {
                    let strTemporaryData = sourceForms.instance;
                    let objTemporaryData = JSON.parse(strTemporaryData);
                    temporaryFormData = objTemporaryData;
                } catch (error) {
                    console.error('解析任务表单数据异常：', error);
                }
            }
            return temporaryFormData;
        },
        async  checkTaskDetail (record) {
            // 1.判断当前任务的任务负责人是否是人当前登录人
            // 2.是的话判断任务是否进行中，进行中则跳转到我的任务列表，不是的话就弹出任务详情
            // console.log(record);
            if (this.readOnly) {
                return;
            }
            if (record.taskUser && record.taskUser.userId === this.currentUserInfo.userId) {
                // 跳转到任务，并打开详情
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let taskInfo = await getProcessTaskDetail(record.id);
                loading.close();
                let processTaskStr = {};
                processTaskStr.processInstanceId = this.processInstanceId;
                processTaskStr.processInstanceName = this.processInstanceName;
                processTaskStr.taskInstanceId = record.id;
                processTaskStr.taskName = record.name;
                processTaskStr.taskState = taskInfo.taskState;
                let processTaskJson = JSON.stringify(processTaskStr);
                sessionStorage.setItem('navToTaskList', processTaskJson);
                // console.log(this.isFromBusTab);
                // 跳转页面
                if (this.isFromBusTab) { // 来源于新版的应用tab
                    this.$emit('navToBusiniessTaskTab');
                } else {
                    this.$emit('navToMyTaskMyAssignee');
                }
            } else {
            // this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
                this.showTaskDetailDialog(record);
            }
        },
        async showTaskDetailDialog (record) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let instances = await getProcessInstancesDetail(record.processInstanceId);
            loading.close();
            // 流程发起人、负责人、抄送人可查看任务详情
            let isCopyUser = false;
            if (instances.copyUserList && instances.copyUserList.length > 0) {
            // 当前登录人是否是抄送人
                for (let item of instances.copyUserList) {
                    if (this.currentUserInfo.userId === item.copyUserId) {
                        isCopyUser = true;
                    }
                }
            }
            if (this.currentUserInfo.userId === instances.startedBy.id ||
            (instances.assigneeUserId !== undefined && instances.assigneeUserId !== '' && instances.assigneeUserId === this.currentUserInfo.userId) ||
            isCopyUser) {
                this.isShowTaskDetail = false;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.taskInfo = await getProcessTaskDetail(record.id);
                setTimeout(() => {
                    this.$refs.taskDetailRef._initFormData();
                }, 0);
                loading.close();
                this.isShowTaskDetail = true;
            } else {
                this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
            }
        },
        async sendUrgeMessage (row) {
        // console.log(row);
            let urgeMessageBO = {
                msgType: 0, // 催办消息类型：0流程、1审批
                processInstanceId: row.processInstanceId,
                processInstanceName: this.processInstanceName,
                taskInstanceId: row.id,
                taskName: row.name,
                receivedUserIds: row.assignee.id,
                receivedUserNames: row.assignee.trueName
            };
            if (row.assignee && row.assignee.id) {
                this.$confirm('您确定要给当前任务负责人【' + row.assignee.trueName + '】发送催办消息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await sendUrgeMessage(urgeMessageBO);
                    this.$emit('refresh');
                    loading.close();
                }).catch(() => {});
            } else {
                this.$message({message: '当前任务尚未设置负责人，请联系流程负责人处理', type: 'warning'});
            }
        },
        activeClass (item) {
            let approvalStatus = 0;
            if (item.relateApprovalStatusList) {
                if (item.relateApprovalStatusList.indexOf(',') !== -1) {
                    approvalStatus = item.relateApprovalStatusList.split(',')[0];
                } else {
                    approvalStatus = item.relateApprovalStatusList;
                }
                // 1审批中 2通过 3驳回
                if (approvalStatus === '1') {
                    item.relateApprovalStatusLabel = '进行中';
                    return 'doing';
                } else if (approvalStatus === '2') {
                    item.relateApprovalStatusLabel = '通过';
                    return 'success';
                } else if (approvalStatus === '3') {
                    item.relateApprovalStatusLabel = '驳回';
                    return 'reject';
                } else if (approvalStatus === '4') {
                    item.relateApprovalStatusLabel = '已终止';
                    return 'terminal';
                } else {
                    return '';
                }
            }
        },
        async handleApprovalDetail (record) {
            this.approvalDetail = {};
            let approvalInstanceId;
            if (record.relateApprovalInstanceIdList) {
                if (record.relateApprovalInstanceIdList.indexOf(',') !== -1) {
                    approvalInstanceId = record.relateApprovalInstanceIdList.split(',')[0];
                } else {
                    approvalInstanceId = record.relateApprovalInstanceIdList;
                }
            }
            if (approvalInstanceId) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.approvalDetail = await getApprovalInstanceDetail(approvalInstanceId);
                this.isShowDynamicApprovalPop = true;
                loading.close();
            }
        },
        async  viewProcessDetail (row) {
            // console.log(row);
            this.isShowProcessInstanceDetail = false;
            this.isShowDetail = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.instancesInfo = await getProcessInstancesDetail(this.processInstanceId);
            loading.close();
            this.isShowProcessInstanceDetail = true;
            this.loadTimer = new Date().getTime();
            this.isShowDetail = true;
        }
    }
};
</script>

<style lang="less">
      .el-tooltip {
          .approvalStatus {
             .doing{
                  color: #409eff;
                  border-color: #409eff; 
              } 
              .success{
                  color: #67c23a;
                  border-color: #67c23a;
              }
              .reject{
                  color: #f56c6c;
              }
              
              .terminal{
                  color: #E6A23C;
              }
          }
    }
      
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/AsynCurrentTasksColumn.vue